// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const notificationApi = baseApi.injectEndpoints({
  reducerPath: "notificationApi",

  // mode: "no-cors",
  // credentials: "include",
  endpoints: (builder) => ({
    sentNotification: builder.mutation({
      query: (data) => {
        return {
          url: "send-notification",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSentNotificationMutation } = notificationApi;
